import styles from "./SearchInputDesktop.module.scss";
import SearchModalDesktop from "@Components/SearchModalDesktop";
import wrapperHOC from "@Utils/wrapperHOC";

const SearchInputHome = () => (
  <>
    <div className={styles.searchInputContainer}>
      <SearchModalDesktop />
    </div>
  </>
);

export default wrapperHOC(SearchInputHome, {
  componentName: "SearchInputHome-HeroSectionDesktop-Home",
  showForChina: true,
});
